import React from 'react';
import './politika.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const Politika = () => {
  return (
    <>
        <Header />
        <div className='corporate-policy-container'>
            {/* Üst Banner Alanı */}
            <div className='corporate-policy-banner'>
                <h1 className='corporate-policy-banner-title'>İnsan Kaynakları Politikası</h1>
                <p className='corporate-policy-subtitle'>İnsana Değer Veren, Gelişime Açık Bir Kariyer Anlayışı</p>
            </div>

            {/* İçerik Alanı */}
            <div className='corporate-policy-content'>
                <div className='corporate-policy-intro'>
                    <p>
                        <strong>ÖNDER İmam Hatipliler Derneği olarak geliştirdiğimiz Kariyer Platformu</strong>, derneğimiz bünyesindeki iş ilanlarını paylaşmaktadır. Hem iş hayatında <strong>tecrübe sahibi</strong> profesyonellere hem de henüz yolun başında olan <strong>gençlere</strong> kapılarını açarak ortak hedefler doğrultusunda yapılacak çalışmalarla ÖNDER markasının güçlenmesini hedeflemektedir.
                    </p>
                </div>

                {/* Temel İlkeler Bölümü */}
                <div className='corporate-policy-section'>
                    <h2 className='corporate-policy-section-title'>İnsan Kaynakları Politikamızın Temel İlkeleri</h2>
                    
                    <ul className='corporate-policy-list'>
                        <li>Derneğimizin misyon ve vizyonu ile uyumlu olarak tecrübe ve mesleki yetkinliğe sahip kişileri istihdam etmek.</li>
                        <li>Genç yetenekleri keşfederek eğitim programları ile desteklemek ve kendi insan kaynağını oluşturmak.</li>
                        <li>Çalışanın kişiliğine saygı duyan, adil, iletişime açık, şeffaf, katılımcı ve değer üreten bir kurum olmak.</li>
                        <li>Çalışanların sosyal ve kültürel ihtiyaçlarının karşılanarak verimliliğinin artırılması.</li>
                        <li>Çalışanların ve tüm paydaşların aidiyetini güçlendirecek ortak bir kurum kültürünün oluşmasını sağlamak.</li>
                        <li>Etkin performans yönetim sistemi ile nitelikli ve özgüveni yüksek kişilerle çalışmak. Onların kariyer yolunda başarılı bir şekilde ilerlemesine imkan tanımak.</li>
                        <li>Kurumsal hedeflere ulaşmak amacıyla insan kaynağını güçlendirmek, çalışanların mesleki bilgi ve yetkinliklerini geliştirebileceği yurt içi ve yurt dışı hizmet içi eğitim imkanları sunmak.</li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer />
    </>
  );
};

export default Politika;